/**
 * Traducao pt-BR.
 *
 * Tipada como TranslationResource, que espelha a arvore de chaves de `en` porem
 * com valores string (e nao os literais do ingles). Isso garante, em tempo de
 * compilacao, que a estrutura de chaves permaneca compativel com a referencia.
 * Caso alguma chave seja removida daqui, o i18next usa automaticamente o ingles
 * como fallback, sem quebrar a aplicacao.
 */
var ptBR = {
    common: {
        next: 'Próximo',
        back: 'Voltar',
        cancel: 'Cancelar',
        confirm: 'Confirmar',
        continue: 'Continuar',
        tryAgain: 'Tentar novamente',
        loading: 'Carregando...',
        secureEnvironment: 'Você está em um ambiente seguro',
    },
    termsConsent: {
        progress: 'ETAPA {{current}} DE {{total}}',
        title: 'Sua privacidade importa',
        subtitle: 'Antes de continuar, conheça como seus dados serão utilizados.',
    },
    initial: {
        noConfiguration: 'Não encontramos nenhuma configuração para o produto indicado',
        initialImageAlt: 'Imagem inicial',
        tryAgain: 'Tentar Novamente',
        version: 'Versão {{version}}',
    },
    confirmation: {
        success: 'Onboarding realizado com sucesso! Token de consulta: {{token}}',
        restart: 'Reiniciar Onboarding',
    },
    errors: {
        generic: 'Ocorreu um erro. Tente novamente.',
        required: 'Este campo é obrigatório.',
        fetchParams: 'Falha ao buscar parâmetros',
        productNotFound: 'Produto não encontrado, favor gerar outro!',
        insufficientBalance: 'Não foi possível iniciar esse onboarding, entre em contato com a empresa',
        onboardingTokenFailed: 'Falha na obtenção do token do onboarding.',
        invalidOnboarding: 'Onboarding inválido, tente novamente outro!',
        invalidOnboardingRetry: 'Onboarding inválido. Tente novamente.',
        invalidToken: 'Token inválido',
        onboardingAlreadyFinished: 'Onboarding já finalizado, favor gerar outro caso queira refazer!',
        tokenCanceled: 'Token já foi cancelado, favor gerar outro!',
        passkeyStepInvalid: 'Step Passkey inválido.',
        passkeyInvalidResponse: 'Resposta inválida ao salvar o resultado da passkey.',
        pdfError: 'Erro ao processar o PDF. Tente novamente.',
    },
    form: {
        scrollForMore: 'Role para ver mais campos',
        required: 'Campo obrigatório',
        invalidCpf: 'CPF inválido',
        invalidCnpj: 'CNPJ inválido',
        invalidRg: 'RG inválido',
        invalidZipcode: 'CEP inválido',
        invalidAccount: 'Conta inválida',
        invalidBankAgency: 'Agência inválida',
        invalidEmail: 'E-mail inválido',
        invalidPhone: 'Telefone inválido',
        invalidPassword: 'Senha inválida',
        passwordsDoNotMatch: 'Senhas não conferem',
    },
    passkey: {
        title: 'Verificação de identidade',
        descriptionLogin: 'Use sua passkey para reutilizar sua verificação de identidade.',
        descriptionRegister: 'Registre uma passkey para proteger e reutilizar sua verificação de identidade.',
        descriptionValidating: 'Aguarde enquanto validamos sua passkey.',
        loginAction: 'Entrar com passkey',
        registerAction: 'Registrar passkey',
        fullNameLabel: 'Nome completo *',
        cpfLabel: 'CPF *',
        birthDateLabel: 'Data de nascimento *',
        fullNameRequired: 'Informe o nome completo.',
        cpfInvalid: 'Informe um CPF válido.',
        birthDateInvalid: 'Informe uma data de nascimento válida.',
        saveFailed: 'Não foi possível salvar o resultado da passkey. Tente novamente.',
        dataMissing: 'Os dados necessários para a passkey estão ausentes ou inválidos.',
        notSupported: 'Passkeys não são suportadas neste navegador.',
        authSuccess: 'Autenticação com passkey realizada com sucesso.',
        registerSuccess: 'Passkey registrada com sucesso. Continue para concluir sua verificação.',
        authFailed: 'Não foi possível autenticar com a passkey. A verificação continuará normalmente.',
        registerFailed: 'Não foi possível registrar a passkey. A verificação continuará normalmente.',
        continuesNormally: '{{message}} A verificação continuará normalmente.',
    },
    flow: {
        stepAlreadyDone_one: 'Essa step já foi realizada. Pulando {{count}} etapa...',
        stepAlreadyDone_other: 'Essa step já foi realizada. Pulando {{count}} etapas...',
    },
    camera: {
        failureTitle: 'Não foi possível abrir a câmera',
        unavailable: 'Abra este cadastro em uma página HTTPS no Safari e permita o acesso à câmera.',
        retryAccess: 'Não foi possível iniciar a câmera. Feche outros aplicativos que estejam usando a câmera e tente novamente.',
        decisionFailed: 'Não foi possível avançar para o envio de documentos. Verifique sua conexão e tente novamente.',
        notFoundTitle: 'Câmera não encontrada',
        notFoundMessage: 'Por favor verifique se o seu dispositivo possui uma câmera ativa e se ela está devidamente configurada.',
        enableTitle: 'Ative sua câmera',
        enableMessage: 'As permissões de câmera estão desativadas para o navegador! Por favor, verifique a permissão nas configurações do seu navegador.',
        permissionDenied: 'Permissão de câmera não foi concedida. Por favor, conceda a permissão de câmera para a página.',
        permissionDeniedShort: 'Permissão de câmera negada. Por favor, permita o acesso à câmera.',
        notFoundOnDevice: 'Nenhuma câmera encontrada no dispositivo.',
        inUse: 'Câmera está sendo usada por outro aplicativo. Feche outros apps que usam a câmera.',
        unsupportedConfig: 'Configuração de câmera não suportada. Tentando com configurações padrão.',
        accessError: 'Erro ao acessar câmera: {{message}}',
        invalidFormat: 'Formato inválido.',
        lowQuality: 'Qualidade da imagem baixa! Escolha outra por favor!',
        switchCamera: 'Trocar câmera',
        loadError: 'Ocorreu um erro ao carregar câmera do seu dispositivo. Por favor, verifique as permissões ou tente com um outro navegador.',
        chooseDocumentBack: 'Escolha o verso do documento, o lado que não tem a foto!',
        chooseDocumentFront: 'Escolha a frente do documento, o lado que tem a foto!',
        invalidCnpjDocument: 'Documento inválido, escolha um cartão CNPJ, contrato social ou estatuto!',
        pdfMaxTwoPages: 'O PDF deve conter no máximo duas páginas (frente e verso).',
        pdfMaxThirtyPages: 'O contrato social ou estatuto deve conter no máximo 30 páginas.',
        lowImageQuality: 'Qualidade da imagem baixa! Escolha outra por favor!',
        takingImageError: 'Ocorreu um erro ao tirar a imagem. Tente novamente.',
        fileTooLarge: 'Arquivo muito grande. Envie um arquivo menor que 10MB.',
        lockFile: 'O arquivo submetido possui senha. Por favor, envie um arquivo sem senha.',
        blurryImage: 'A imagem está muito borrada. Segure o celular firme e tente novamente.',
        darkImage: 'A imagem está muito escura. Procure um ambiente com mais luz.',
        lowContrastImage: 'A imagem está com pouco contraste. Aproxime a câmera e evite reflexos.',
        lowResolutionImage: 'A imagem está com resolução muito baixa. Tente novamente ou envie uma imagem com melhor resolução.',
        acceptingLowQuality: 'Enviando mesmo com qualidade baixa, pois a foto foi reprovada várias vezes.',
        noDocumentDetected: 'Posicione o documento dentro do quadro.',
        holdSteady: 'Segure firme, está tremendo.',
        misalignedDocument: 'Ajuste o documento dentro do quadro.',
        moveCloser: 'Aproxime o documento da câmera.',
        moveFarther: 'Afaste um pouco o documento.',
        moveLeft: 'Mova o documento para a esquerda.',
        moveRight: 'Mova o documento para a direita.',
        moveUp: 'Mova o documento para cima.',
        moveDown: 'Mova o documento para baixo.',
        wellFramedDocument: 'Documento bem posicionado!',
    },
    liveness: {
        title: 'Foto para Verificação',
        intro: 'Precisamos tirar uma foto sua. Antes de começar:',
        tipLighting: 'Certifique-se de estar em um ambiente <strong>bem iluminado</strong>.',
        tipAccessories: '<strong>Remova óculos, bonés ou qualquer acessório que possa ocultar o rosto.</strong>',
        tipCentered: 'Mantenha o rosto centralizado na tela.',
        outro: 'Por favor, esteja atento às orientações que serão fornecidas durante o processo.',
        startError: 'Não foi possível iniciar a prova de vida. Tente novamente.',
        sessionError: 'Erro ao obter session_id',
        frameFace: 'Enquadre o rosto na máscara desenhada',
        startChallenge: 'Iniciar desafio',
        startLiveness: 'Iniciar Liveness',
    },
    onboardingHelp: {
        open: "Abrir ajuda",
        close: "Fechar ajuda",
        title: "Como podemos ajudar?",
        done: "Entendi",
        howTitle: "Como funciona",
        howText: "Siga as etapas apresentadas na tela. As informações solicitadas dependem da verificação configurada pela empresa.",
        documentTitle: "Envio do documento",
        documentText: "Use boa iluminação, evite reflexos e mantenha todas as bordas do documento visíveis. Confira se os dados estão legíveis antes de confirmar. Se a opção Arquivo estiver disponível, você pode enviar um arquivo do dispositivo.",
        livenessTitle: "Prova de vida",
        livenessText: "Ilumine o rosto, retire acessórios que o cubram e mantenha-o dentro do oval. Siga o gesto solicitado na tela e aguarde a verificação.",
        cameraTitle: "Problemas com a câmera",
        cameraText: "Permita o acesso à câmera quando o navegador solicitar. Se o acesso foi bloqueado, abra as permissões deste site no navegador e habilite a câmera. Feche outros aplicativos que estejam usando a câmera e tente novamente.",
        privacyTitle: "Privacidade e uso dos dados",
        privacyText: "Consulte a política de privacidade e os termos apresentados neste fluxo para entender a finalidade do uso dos seus dados e as condições da verificação.",
        supportTitle: "Preciso de mais ajuda",
        supportText: "Se o problema continuar, entre em contato com a empresa que enviou o link de verificação pelos canais de atendimento informados por ela.",
    },
    verificationIntro: {
        eyebrow: "SUA IDENTIDADE, COM CUIDADO",
        title: "Vamos começar?",
        description: "Verificar sua identidade pode ser simples. Vamos acompanhar você em cada etapa.",
        data: "Seus dados",
        dataDetail: "Um pouco sobre você",
        document: "Documento de identificação",
        documentDetail: "Uma foto, sem complicação",
        selfie: "Uma selfie",
        selfieDetail: "Para saber que é você mesmo",
        minute: "1 min",
        seconds: "30 seg",
        start: "Começar verificação",
    },
    livenessLocal: {
        developerCredit: "Desenvolvido por ReactIt Solutions",
        verification: "VERIFICAÇÃO FACIAL",
        shortFrontal: "Olhar",
        shortLeft: "Esquerda",
        shortRight: "Direita",
        shortBlink: "Piscar",
        shortSmile: "Sorrir",
        hintFrontal: "Mantenha o rosto no centro e olhe para a câmera.",
        hintLeft: "Vire o rosto para a esquerda, mantendo-o dentro do oval.",
        hintRight: "Vire o rosto para a direita, mantendo-o dentro do oval.",
        hintBlink: "Mantenha a cabeça parada e pisque naturalmente.",
        hintSmile: "Olhe para a câmera e sorria naturalmente.",
        visualPreview: "PRÉVIA VISUAL",
        cameraLive: "CÂMERA AO VIVO",
        mockCameraNote: "Prévia visual · sem validação biométrica",
        prepareSubtitle: "Prepare-se para confirmar que é você mesmo.",
        prepareLightingTitle: "Encontre uma boa luz",
        prepareLightingText: "Ilumine o rosto, sem sombras ou contraluz.",
        prepareFaceTitle: "Deixe o rosto livre",
        prepareFaceText: "Retire óculos, bonés e outros acessórios.",
        prepareCameraTitle: "Olhe para a câmera",
        prepareCameraText: "Mantenha o rosto inteiro no centro da tela.",
        prepareFollowTitle: "Acompanhe as orientações",
        prepareNote: "A câmera será ativada ao começar. Siga as orientações para realizar sua prova de vida.",
        prepareMockNote: "Neste modo simulado, a captura é demonstrativa e não realiza prova de vida.",
        prepareStart: "Começar",
        starting: 'Preparando o desafio...',
        checking: 'Verificando...',
        startFailed: 'Não foi possível iniciar o desafio. Tente novamente.',
        saveFailed: 'Não foi possível salvar o resultado. Tente novamente.',
        cameraError: 'Não conseguimos capturar a imagem da câmera.',
        cameraStarting: 'Preparando a câmera...',
        cameraNotReady: 'A câmera ainda não está pronta. Aguarde um instante.',
        challengeNotIssued: 'O serviço de prova de vida não retornou o desafio. Entre em contato com o suporte.',
        introTitle: 'Prova de vida',
        introSubtitle: 'Precisamos confirmar que é você mesmo',
        tipFollow: 'Siga as instruções que aparecerem na tela.',
        startButton: 'Começar',
        successTitle: 'Prova de vida concluída!',
        successMessage: 'Tudo certo. Estamos salvando o resultado...',
        failureTitle: 'Não conseguimos confirmar sua prova de vida',
        capturingIn: 'Capturando em {{seconds}}...',
        notApproved: 'Não foi possível confirmar a prova de vida. Vamos tentar de novo.',
        retry: 'Vamos repetir o desafio.',
        gestureOk: 'Gesto reconhecido.',
        gestureRetry: 'Não reconhecemos o gesto. Tente novamente.',
        gestureCount: 'Gesto {{current}} de {{total}}',
        gestureFrontal: 'Olhe para a câmera',
        gestureTurnLeft: 'Vire o rosto para a esquerda',
        gestureTurnRight: 'Vire o rosto para a direita',
        gestureBlink: 'Pisque os olhos',
        gestureSmile: 'Sorria',
    },
    livenessAws: {
        stepName: 'Prova de Vida',
        takeSelfieTitle: 'Tire uma selfie',
        verifyIdentity: 'Precisamos verificar sua identidade',
        tipLighting: 'Certifique-se de estar em um ambiente bem <strong>iluminado</strong>.',
        tipAccessories: '<strong>Remova</strong> óculos, bonés ou qualquer acessório que possa ocultar o rosto.',
        tipCentered: 'Mantenha o rosto centralizado na tela.',
        starting: 'Iniciando...',
        takeSelfieButton: 'Tirar Selfie',
        analyzing: 'Estamos analisando suas informações',
        couldNotComplete: 'Não foi possível concluir a prova de vida. Tente novamente.',
        lowQualitySelfie: 'Selfie fora do padrão de qualidade. Refaça em ambiente bem iluminado, com rosto centralizado e sem acessórios.',
        notValidated: 'Prova de vida não validada. Tente novamente.',
        couldNotValidate: 'Não foi possível validar a prova de vida. Tente novamente.',
    },
    livenessDetector: {
        photosensitivityWarningHeadingText: 'Aviso de Fotosensibilidade',
        photosensitivityWarningBodyText: 'Esta verificação exibe diferentes cores. Tenha cuidado se você for fotossensível.',
        photosensitivityWarningInfoText: 'Algumas pessoas podem sofrer crises epilépticas quando expostas a luzes coloridas. Tenha cuidado se você, ou alguém em sua família, tem condição epiléptica.',
        photosensitivityWarningLabelText: 'Mais informações sobre fotosensibilidade',
        goodFitCaptionText: 'Bom ajuste',
        goodFitAltText: 'Ilustração do rosto de uma pessoa, encaixando perfeitamente dentro de um oval.',
        tooFarCaptionText: 'Muito longe',
        tooFarAltText: 'Ilustração do rosto de uma pessoa dentro de um oval; há um espaço entre o perímetro do rosto e os limites do oval.',
        hintCenterFaceText: 'Centralize seu rosto',
        hintCenterFaceInstructionText: 'Instrução: Antes de iniciar a verificação, certifique-se de que sua câmera está no centro superior da tela e centralize seu rosto para a câmera. Quando a verificação começar, um oval aparecerá no centro. Você será solicitado a se mover para dentro do oval e, em seguida, a manter-se imóvel. Após alguns segundos, você deve ouvir que a verificação foi concluída.',
        hintFaceOffCenterText: 'O rosto não está no oval, centralize seu rosto para a câmera.',
        hintMoveFaceFrontOfCameraText: 'Mova o rosto para frente da câmera',
        hintTooManyFacesText: 'Certifique-se de que apenas um rosto está na frente da câmera',
        hintFaceDetectedText: 'Rosto detectado',
        hintCanNotIdentifyText: 'Mova o rosto para frente da câmera',
        hintTooCloseText: 'Afaste-se',
        hintTooFarText: 'Aproxime-se',
        hintConnectingText: 'Conectando...',
        hintVerifyingText: 'Verificando...',
        hintCheckCompleteText: 'Verificação concluída',
        hintIlluminationTooBrightText: 'Vá para uma área com menos luz',
        hintIlluminationTooDarkText: 'Vá para uma área mais iluminada',
        hintIlluminationNormalText: 'Condições de iluminação normais',
        hintHoldFaceForFreshnessText: 'Mantenha-se imóvel',
        hintMatchIndicatorText: '50% concluído. Continue se aproximando.',
        startScreenBeginCheckText: 'Começar a verificação',
        cameraMinSpecificationsHeadingText: 'A câmera não atende às especificações mínimas',
        cameraMinSpecificationsMessageText: 'A câmera deve suportar pelo menos resolução de 320*240 e 15 quadros por segundo.',
        cameraNotFoundHeadingText: 'Câmera não acessível.',
        cameraNotFoundMessageText: 'Verifique se uma câmera está conectada e se não há outro aplicativo usando a câmera. Pode ser necessário acessar as configurações para conceder permissões à câmera, fechar todas as instâncias do navegador e tentar novamente.',
        a11yVideoLabelText: 'Webcam para verificação de vivacidade',
        cancelLivenessCheckText: 'Cancelar verificação de vivacidade',
        retryCameraPermissionsText: 'Tentar novamente',
        recordingIndicatorText: 'Gravando',
        waitingCameraPermissionText: 'Aguardando você permitir o uso da câmera.',
        errorLabelText: 'Erro',
        connectionTimeoutHeaderText: 'Tempo de conexão esgotado',
        connectionTimeoutMessageText: 'A conexão expirou.',
        timeoutHeaderText: 'Tempo esgotado',
        timeoutMessageText: 'O rosto não se encaixou no oval dentro do tempo limite. Tente novamente e preencha completamente o oval com o rosto.',
        faceDistanceHeaderText: 'Movimento para frente detectado',
        faceDistanceMessageText: 'Evite se aproximar durante a conexão.',
        multipleFacesHeaderText: 'Vários rostos detectados',
        multipleFacesMessageText: 'Certifique-se de que apenas um rosto esteja na frente da câmera durante a conexão.',
        clientHeaderText: 'Erro no cliente',
        clientMessageText: 'A verificação falhou devido a um problema no cliente',
        serverHeaderText: 'Problema no servidor',
        serverMessageText: 'Não é possível concluir a verificação devido a um problema no servidor',
        landscapeHeaderText: 'Orientação paisagem não suportada',
        landscapeMessageText: 'Gire o dispositivo para a orientação retrato (vertical).',
        portraitMessageText: 'Mantenha o dispositivo na orientação retrato (vertical) durante toda a verificação.',
        tryAgainText: 'Tentar novamente',
    },
    decision: {
        title: 'Envio de Documentos',
        readInstructions: 'Leia as orientações antes de prosseguir',
        chooseOption: 'Escolha uma das opções abaixo',
        preSubmitGeneralTitle: 'Seu documento',
        preSubmitGeneralSubtitle: 'Leia as orientações antes de prosseguir.',
        preSubmitChecklistHeading: 'Antes de enviar, confira:',
        preSubmitChecklistHeadingPrefix: 'Antes de enviar, ',
        preSubmitChecklistHeadingEmphasis: 'confira:',
        preSubmitTipLightingTitle: 'Boa iluminação',
        preSubmitTipLightingDescription: 'Ambiente claro, sem sombra sobre o documento.',
        preSubmitTipCompleteDocumentTitle: 'Documento completo',
        preSubmitTipCompleteDocumentDescription: 'Tudo visível, sem cortar nenhuma borda.',
        preSubmitTipCorrectFileTitle: 'Arquivo certo',
        preSubmitTipCorrectFileDescription: 'Foto ou PDF de até 20 MB, nítido ao ampliar.',
        preSubmitGeneralTip: 'Dica: apoie o documento sobre uma mesa escura e lisa.',
        preSubmitSingleTitle: 'Documento único',
        preSubmitSingleSubtitle: 'Frente e verso na mesma foto.',
        preSubmitSingleHeading: 'Envie o documento aberto, em uma única foto.',
        preSubmitSingleStep: '01 UMA FOTO',
        preSubmitSingleCaption: 'Frente + verso juntos',
        preSubmitSingleCheckOpen: 'Abra o documento para mostrar as duas faces',
        preSubmitSingleCheckComplete: 'Documento inteiro, sem cortar as bordas',
        preSubmitSingleCheckLegible: 'Texto e números nítidos ao ampliar',
        preSubmitSingleCheckNoGlare: 'Sem reflexos, sombras ou dedos na frente',
        preSubmitSingleTip: 'Use fundo escuro e liso: o contraste deixa o texto mais nítido.',
        preSubmitTwoSidedTitle: 'Frente e verso',
        preSubmitTwoSidedSubtitle: 'O envio acontece em duas etapas.',
        preSubmitTwoSidedHeading: 'Envie as duas faces, uma de cada vez.',
        preSubmitTwoSidedHeadingPrefix: 'Envie as duas faces, ',
        preSubmitTwoSidedHeadingEmphasis: 'uma de cada vez.',
        preSubmitTwoSidedFront: 'Frente',
        preSubmitTwoSidedFrontDescription: 'Foto, número e assinatura legíveis',
        preSubmitTwoSidedBack: 'Verso',
        preSubmitTwoSidedBackDescription: 'Código de barras completo, sem cortes',
        preSubmitTwoSidedCheckComplete: 'Documento inteiro, sem cortar as bordas',
        preSubmitTwoSidedCheckLegible: 'Texto e números nítidos ao ampliar',
        preSubmitTwoSidedCheckNoGlare: 'Sem reflexos, sombras ou dedos na frente',
        preSubmitTwoSidedTip: 'Use fundo escuro e liso: o contraste deixa o texto mais nítido.',
    },
    image: {
        dataReviewFields: 'Seus dados',
        dataReviewFieldsHint: 'Confira e altere os campos permitidos.',
        dataReviewSelfie: 'Selfie',
        dataReviewTitle: 'Confirme seus dados',
        dataReviewSubtitle: 'Preenchemos os dados encontrados no documento. Confira, corrija ou complete os campos antes de continuar.',
        dataReviewConfirm: 'Confirmar dados e continuar',
        dataReviewOpenDocument: 'Abrir documento',
        reviewBackendError: "Não foi possível concluir a leitura agora. Tente consultar novamente; o documento já enviado não será reenviado.",
        reviewBackendRetry: "Consultar leitura novamente",
        reviewBackendReading: "Enviando e lendo seu documento. Aguarde...",
        reviewRetake: "Fotografar novamente",
        reviewOcrReference: "Confira os dados do seu documento.",
        reviewLegibility_unavailable: "A análise do documento não foi aprovada. Confira os dados disponíveis.",
        reviewLegibility_unclear: "Leitura inconclusiva. Confira a foto ou fotografe novamente com mais luz e foco.",
        reviewLegibility_legible: "Ver dados do documento",
        reviewSubtitle: "Confira os dados extraídos do seu documento.",
        reviewNameMissing: "Nome não identificado",
        reviewPersonalData: "Nome completo",
        reviewDocumentDetails: "Documento anexado · Ver dados extraídos",
        reviewLiveness: "Liveness",
        reviewLivenessDone: "Prova de vida realizada",
        reviewLivenessPending: "Prova de vida ainda não realizada",
        reviewDone: "Feito",
        reviewLocalNotice: "O documento já foi enviado. Estes dados foram retornados pela análise do documento no backend.",
        reviewTitle: "Tudo certo por aqui?",
        reviewMotherName: "Filiação · Nome da mãe",
        reviewFatherName: "Filiação · Nome do pai",
        reviewBirthplace: "Naturalidade (cidade e estado)",
        reviewParentageHint: "Filiação encontrada no documento:",
        reviewName: "Nome completo",
        reviewBirthDate: "Data de nascimento",
        reviewReading: "Lendo seu documento...",
        reviewOcrFailed: "Não foi possível ler os dados automaticamente. Confira o documento e preencha os campos que conseguir identificar.",
        reviewOcrReady: "Confira os dados reconhecidos e corrija qualquer informação incorreta.",
        reviewNotFound: "Não identificado",
        reviewDocuments: "{{count}} imagem(ns) ou arquivo(s) do documento anexado(s)",
        reviewNoticeTitle: "Confira antes de enviar",
        reviewNotice: "A leitura automática pode conter erros. O documento será enviado somente ao confirmar abaixo.",
        reviewSubmit: "Continuar",
        previewTitle: "Confira seu documento",
        previewSubtitle: "Veja se todos os campos estão legíveis antes de confirmar.",
        previewImageAlt: "Documento anexado para conferência",
        previewAttached: "Documento anexado",
        previewWarningTitle: "Antes de confirmar, confira:",
        previewWarning: "Ao confirmar, seu documento será enviado para análise. Aguarde a leitura antes de continuar.",
        previewConfirm: "Confirmar documento",
        reviewWarning: 'Verifique se a imagem a ser enviada está nítida e com todos os campos legíveis antes de confirmar.',
        reviewWarningLabel: 'Atenção:',
        introTitleTwoSided: 'Envio frente e verso',
        introTitleSingle: 'Envio de documento',
        introSubtitleTwoSided: 'O envio será realizado em duas etapas.',
        introSubtitleSingle: 'Você poderá enviar um único arquivo ou tirar uma foto.',
        introTextTwoSided: 'Nesta modalidade, o sistema solicitará primeiro a frente e depois o verso do documento. Certifique-se de que cada lado esteja legível, completo e bem posicionado na imagem.',
        introTextSingle: 'Nesta modalidade, o documento pode ser apresentado em um único arquivo ou em uma única imagem, desde que todas as informações necessárias estejam legíveis e completas para análise.',
        searchDigitalDocument: 'Buscar Documento Digital',
        front: 'Frente',
        back: 'Verso',
        document: 'Documento',
        backgroundTip: 'Prefira um fundo escuro e liso para facilitar a leitura do documento.',
        captureSingleTitle: 'Documento envio único',
        processingDocument: 'Processando documento...',
        preparingNextSide: 'Preparando a câmera para o verso...',
        captureHeader: 'CAPTURA DO DOCUMENTO',
        captureInstruction: 'Posicione o documento dentro da marcação',
        captureHint: 'Mantenha firme e evite reflexos',
        captureFile: 'Arquivo',
        captureSwitch: 'Trocar',
        captureSessionNote: 'Demonstração · foto apenas nesta sessão',
    },
    selfie: {
        takePhoto: 'Tirar foto',
        retakePhoto: 'Tirar outra foto',
        sendPhoto: 'Enviar foto',
        searchDigitalDocument: 'Buscar Documento digital',
    },
    success: {
        title: "Jornada concluída",
        description: "Você completou todas as etapas desta jornada.",
        footer: "Ambiente seguro • Seus dados estão protegidos",
        step: "ETAPA {{current}} DE {{total}}",
        closingPage: 'Vou tentar fechar a página',
    },
    qrcode: {
        nextStep: 'Próximo passo:',
        useCameraInfo: 'Usaremos a câmera do seu dispositivo para confirmar que é você',
        continueOnThisDevice: 'Você quer continuar o cadastro neste dispositivo?',
        yesContinueHere: 'Sim, continuar aqui',
        noUseAnotherDevice: 'Não, usar outro dispositivo',
        scanInstruction: 'Utilize o QRCode abaixo para continuar em outro dispositivo',
    },
    result: {
        title: 'Resultados',
        livenessAlt: 'Prova de vida',
        loadFailed: 'Não foi possível carregar os resultados.',
        updating: 'Os resultados ainda estão sendo atualizados.',
        updateFailed: 'Não foi possível atualizar agora. Tentaremos novamente.',
        empty: 'Nenhum resultado disponível.',
        servicesLabel: 'Resultados das consultas',
        statusApproved: 'Aprovado',
        statusNew: 'Aguardando processamento',
        statusRejected: 'Rejeitado',
        statusProcessing: 'Em processamento',
        statusPending: 'Pendente',
        statusPartial: 'Parcial',
        statusError: 'Não foi possível concluir',
        statusUnavailable: 'Status indisponível',
    },
    serviceFields: {
        state: 'Estado',
        sex: 'Sexo',
        mother_name: 'Nome da mãe',
        rg_issuer: 'Órgão emissor do RG',
        father_name: 'Nome do pai',
        cnh_expiration: 'Validade da CNH',
        cnh_category: 'Categoria da CNH',
        cnh_number: 'Número da CNH',
        rg_number: 'Número do RG',
        name: 'Nome Completo',
        cnh_paid_activity: 'Atividade remunerada da CNH',
        cnh_renach: 'RENACH da CNH',
        cnh_doc_emission_place: 'Local de emissão da CNH',
        classification: 'Classificação',
        doc_type: 'Tipo de documento',
        file_type: 'Tipo de arquivo',
        nationality: 'Nacionalidade',
        valid_date: 'Data de validade',
        dt_rg_issue: 'Data de emissão do RG',
        cnh_last_emission_date: 'Data da última emissão da CNH',
        cnh_first_qualification_date: 'Data da primeira habilitação',
        birth_date: 'Data de nascimento',
        issue_date: 'Data de emissão',
        cpf: 'CPF',
        registration_number: 'Número de registro',
        doc_emission_place: 'Local de emissão do documento',
        issue_country: 'País de emissão',
        passaport_type: 'Tipo de passaporte',
        passaport_number: 'Número do passaporte',
        authority: 'Autoridade',
        naturality: 'Naturalidade',
        is_organ_donor: 'É doador de órgãos',
        via: 'Via do documento',
        observations: 'Observações',
        rne_valid_date: 'Data de validade do RNE',
        rnm_number: 'Número do RNM',
        rne_number: 'Número do RNE',
        residence_period: 'Período de residência',
        issue_body: 'Órgão emissor',
        entry_date: 'Data de entrada',
        result_liveness_3d: 'Resultado da verificação do Liveness 3D',
    },
    serviceNames: {
        service_ocr: 'Extração de informações do documento de identificação',
        service_liveness_3d_aws: 'Prova de vida',
        service_face_match: 'Comparação facial',
    },
    serviceMessages: {
        service_ocr__approved: 'OCR realizado com sucesso',
        service_ocr__new: 'Documento não encontrado!',
        service_ocr__canceled: 'Documento não encontrado!',
        service_ocr__in_process: 'Em Andamento',
        service_liveness_3d_aws__approved: 'Liveness validado com sucesso',
        service_liveness_3d_aws__refused: 'Não foi possível validar o Liveness 3D',
        service_liveness_3d_aws__in_process: 'Em Andamento',
        service_face_match__approved: 'Score de Similaridade: {{score}}',
        service_face_match__approved_fallback: 'Face confere',
        service_face_match__new: 'Documento de identificação não encontrado na base de dados',
        service_face_match__refused: 'Faces diferentes',
        service_face_match__error: 'Falha ao comparar face com documento',
    },
};
export default ptBR;
